import Box from '@material-ui/core/Box'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { makeStyles } from '@material-ui/core/styles'
import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { useAuthentication } from '../../../hooks/Authentication/useAuthentication'
import useValidation from '../../../hooks/Validation/useValidation'
import { loadingAndText, ROUTES } from '../../../shared/constants'
import CustomButton from '../../CustomButton'
import AuthInputField from '../../AuthInputField'
import CustomLabel from '../../CustomLabel'
import PoweredByNural from '../../PoweredByNural'
import { Link } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress'
import { environment } from '../../../shared/API'

const useStyles = makeStyles((theme) => ({
  marginTop: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '40px',
    },
  },
  label: {
    color: 'black',
    fontSize: '12px',
    lineHeight: '20px',
    marginLeft: '45px',
  },
  loginOption: {
    position: 'relative',
    bottom: '-39px',
    margin: '0px 10%',
  },
  link: {
    color: '#32499F',
    cursor: 'pointer',
    marginLeft: '3px',
    '&:hover': { textDecoration: 'underline' },
    fontSize: '12px',
  },
  link2: {
    color: '#32499F',
    cursor: 'pointer',
    // marginLeft: '3px',
    '&:hover': { textDecoration: 'underline' },
    fontSize: '14px',
    marginTop: '10px',
  },
  options: {
    marginTop: '20px',
    // textAlign: 'center',
    // margin: '0px 54px',
    display: 'flex',

    // justifyContent: 'center',
  },
}))

export default function LoginForm() {
  const classes = useStyles()
  const history = useHistory()
  // 7053617608
  const [email, setEmail] = useState(environment === 'local' ? 'deepak@superAdmin.com' : '')
  const [password, setPassword] = useState(environment === 'local' ? 'password' : '')
  const { error, handleValidation } = useValidation()
  const { loading, loginUser } = useAuthentication()

  const handleLogin = () => {
    loginUser({ phoneNumber: email, password: password })
  }

  return (
    <form>
      <AuthInputField
        placeholder="Email/Mobile"
        onKeyDown={() => handleValidation('email', email)}
        className={classes.marginTop}
        errorMessage={error && error.email}
        handleChange={setEmail}
        value={email}
      />
      <AuthInputField
        placeholder="Password"
        onKeyDown={() => handleValidation('password', password)}
        className={classes.marginTop}
        errorMessage={error && error.password}
        handleChange={setPassword}
        value={password}
        type="password"
      />
      <br />
      <br />

      <Box display="flex" justifyContent="space-between">
        <FormControlLabel control={<Checkbox value="remember" color="primary" />} label="Remember me" />
        <Link className={`${classes.label} ${classes.link2}`} to={ROUTES.FORGOT_PASSWORD}>
          {' '}
          Forgot Password ?{' '}
        </Link>
      </Box>

      <CustomButton disabled={loading} text={loadingAndText(loading, 'Login')} className={classes.marginTop} handleSubmit={handleLogin} />
      <br />

      <Box display="flex" className={classes.options}>
        <CustomLabel label="Don't have an account ?" className={classes.label} />
        <div className={`${classes.label} ${classes.link}`} onClick={() => history.push(ROUTES.SIGNUP)}>
          Create an account
        </div>
      </Box>
      {/* <div className={classes.loginOption}>
        <PoweredByNural />
      </div> */}
    </form>
  )
}
